export const baseURL = process.env.REACT_APP_BASE_URL;
export const env = process.env.REACT_APP_ENV;
